/**
 * Projects data configuration
 * Contains all project information including images, descriptions, and metadata
 */

export const projects = [
  {
    title: "Sotto Live Music Bar",
    category: "hospitality",
    coverImage: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/6bfc35eb2575aa35_sotto-bar-08-singer-silhouette.jpg",
    coverImageAlt: "Sotto Live Music Bar — Singer silhouetted against the glowing moon lamp",
    metaDescription: "Sotto Live Music Bar: An atmospheric underground bar and live music venue featuring dramatic amber lighting, exposed brick, and curved architectural elements. Intimate hospitality design creating an immersive nightlife experience.",
    images: [
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/6bfc35eb2575aa35_sotto-bar-08-singer-silhouette.jpg",
        alt: "Sotto Live Music Bar - Singer silhouetted against the moon lamp during performance"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/37151f98ebba6a66_sotto-bar-16-main-room-stage.jpg",
        alt: "Sotto Live Music Bar - Main room with high tables and illuminated stage with moon lamp centerpiece"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/56be1dbc1ed70cb0_sotto-bar-13-bar-counter-microphone.jpg",
        alt: "Sotto Live Music Bar - Bar counter with stools and vintage microphone stand"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/1dde8796aab00daa_sotto-bar-09-stage-performer-wide.jpg",
        alt: "Sotto Live Music Bar - Performer on stage framed by warm bar lighting and atmospheric glow"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/de6e9d41b410a953_sotto-bar-14-brick-booth.jpg",
        alt: "Sotto Live Music Bar - Leather booth set against white brick wall with candle shelves"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/822d089367559555_sotto-bar-07-moon-lamp-banquette.jpg",
        alt: "Sotto Live Music Bar - Moon lamp and curved banquette with backlit bottle shelves"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/43f782048ac359bd_sotto-bar-12-curved-stone-light-detail.jpg",
        alt: "Sotto Live Music Bar - Detail of curved stone surface with hidden LED lighting"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/538b57d1db5c0fcd_sotto-bar-19-candle-wall-banquette.jpg",
        alt: "Sotto Live Music Bar - Long banquette below candle-lit wall with warm ambient glow"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/ab990b58d2df4921_sotto-bar-10-banquette-niche.jpg",
        alt: "Sotto Live Music Bar - Intimate banquette seating niche with warm candlelit atmosphere"
      },
      {
        url: "/images/sotto/SOTTO_Sketch_02_Form_Development.jpg",
        alt: "Sotto Live Music Bar - Form development sketch exploring the circular bar element and spatial relationships"
      },
      {
        url: "/images/sotto/SOTTO_Sketch_03_Design_Intent.jpg",
        alt: "Sotto Live Music Bar - Design intent sketch with handwritten notes capturing the atmospheric concept"
      },
      {
        url: "/images/sotto/SOTTO_Sketch_01_Spatial_Studies.jpg",
        alt: "Sotto Live Music Bar - Initial spatial studies sketch showcasing conceptual layout and circulation"
      }
    ],
    description: "A sun at the centre of a dark room — the pulling force everything orbits. Amber reflections off brass, smoky mirrors catching silhouettes, illuminated bottles glowing like offerings. Candles. A moving crowd.\n\nMusicians emerging from the bar as if the space itself conjured them. Bar Sotto is designed as a visual magnet — a room that draws you in before a single note is played, and keeps revealing itself long after.",
    photographer: "dikanyas_studio",
    location: "Sofia, Bulgaria"
  },
  {
    id: 5,
    title: "Social Studio",
    category: "commercial",
    coverImage: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/v5yr41yg_DSC_5650-2.jpg",
    coverImageAlt: "Social Studio — Reception area with lush greenery against terracotta walls",
    coverImagePosition: "40% center",
    metaDescription: "Social Studio: A pilates reformer studio in Sofia where a single terracotta red transforms the entire space. Bold color choice creates an energized, intentional atmosphere that elevates the physical practice.",
    images: [
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/dexg5xch_DSC_5605-2.jpg",
        alt: "Social Studio - Main pilates reformer studio with terracotta red walls, arched mirrors, and warm wooden flooring"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/t40ik4jf_DSC_5619-2.jpg",
        alt: "Social Studio - Pilates reformers arranged in studio with black reception desk and Social Studio branding"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/v5yr41yg_DSC_5650-2.jpg",
        alt: "Social Studio - Reception area with Social Studio logo, warm wood counter, and lush greenery against terracotta walls"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/06p81e8o_DSC_5682.jpg",
        alt: "Social Studio - Pilates equipment with signature arched black mirrors creating dramatic reflections in the red space"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/c3k65ajx_DSC_5692.jpg",
        alt: "Social Studio - Full studio view showing arched mirrors, reformer equipment, and the flowing terracotta color scheme"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/cnq47nee_DSC_5760.jpg",
        alt: "Social Studio - Intimate lounge area with terracotta walls, relaxation reformer bed, and warm ambient lighting"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/rizbo39y_DSC_5813.jpg",
        alt: "Social Studio - Detail of lush tropical plant against terracotta walls with photography books on circular table"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/evp4hd7l_DSC_5817.jpg",
        alt: "Social Studio - Waiting area with terracotta bench, framed portrait, and warm wood paneling"
      }
    ],
    description: "Red is not a background color. It's a decision.\n\nWhen Social Studio came to us, they already knew what they wanted to feel — energized, intentional, unapologetically physical. We took that seriously. A single terracotta red, applied everywhere: ceiling, walls, every surface. Not to decorate — to transform.\n\nThe color does the work a pilates studio rarely lets itself do. It makes the space feel charged before you even step on the reformer. The warmth wraps you in; the depth pulls you forward. What could have been clinical becomes almost ceremonial — a room that tells you this is where effort happens.\n\nNatural light does the rest. Against the red, it shifts through the day — morning terracotta, afternoon ember, early evening rust. The space is never the same twice, but it always feels like it means something.\n\nThis is what paint can do when you stop treating it as finish and start treating it as material.",
    location: "Pilates Reformer Studio, Sofia"
  },
  {
    id: 1,
    id: 6,
    id: 7,
    title: "Hotel Perelik — Guest Room",
    category: "hospitality",
    coverImage: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/0c960016e0d70c6a_hotel-perelik-room-02-bed.jpg",
    coverImageAlt: "Hotel Perelik Guest Room — Upholstered headboard and wood-toned wall panels",
    coverImagePosition: "center 45%",
    metaDescription: "A light renovation of a guest room at Hotel Perelik — decorative wall panels by Design Squad, warm materials and a cosy, classic hotel interior. Design by element by elena mustakova.",
    images: [
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/0b93307cb3d2cbe3_hotel-perelik-room-01-room-overview.jpg",
        alt: "Hotel Perelik guest room – overview with decorative wall panels"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/0c960016e0d70c6a_hotel-perelik-room-02-bed.jpg",
        alt: "Hotel Perelik guest room – upholstered headboard and wood-toned wall panels"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/790cfd5055bb279c_hotel-perelik-room-03-living-area.jpg",
        alt: "Hotel Perelik guest room – sitting area and bedroom"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/f9f9ae9973dc0158_hotel-perelik-room-04-lounge-to-desk.jpg",
        alt: "Hotel Perelik guest room – sofa, terracotta armchair and desk"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/ab150fb15f2d2cda_hotel-perelik-room-05-sofa-detail.jpg",
        alt: "Hotel Perelik guest room – sofa and textile-look wall panels"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/5e4346e329aff5ff_hotel-perelik-room-06-lounge-from-above.jpg",
        alt: "Hotel Perelik guest room – lounge seen from above"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/839d682ee411d7d6_hotel-perelik-room-07-bed-to-desk.jpg",
        alt: "Hotel Perelik guest room – view from the bed toward the desk"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/407f56807d4b3856_hotel-perelik-room-08-bed-to-lounge.jpg",
        alt: "Hotel Perelik guest room – view from the bed toward the lounge"
      }
    ],
    description: "The brief was to refresh the hotel's guest rooms with minimal intervention: no demolition, short downtime and a result that lasts.\n\nThe answer is in the walls. Decorative wall panels by Design Squad wrap the room in a soft, textile-like surface, divided by fine dark lines that give it a calm, tailored rhythm. Behind the bed, warm wood-toned panels frame an upholstered headboard and add comfort and depth.\n\nThe palette is warm and grounded — linen, sand and walnut, with accents of terracotta and sage in the furniture. A sculptural armchair, a solid-wood coffee table and a generous sofa turn the room into a place to stay in, not just to sleep in. Indirect cove lighting and glass wall lights complete the atmosphere.\n\nThe result feels classic without being old-fashioned: a room to come back to after a day in the mountains.",
    client: "Hotel Perelik",
    location: "Pamporovo, Bulgaria",
    projectType: "Hospitality — hotel guest room",
    scope: "Light renovation, interior design",
    wallPanels: "Design Squad",
    year: "2026",
    designer: "element by elena mustakova"
  },
  {
    title: "La Dolce Casa",
    category: "residential",
    coverImage: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/3d20245735aaa05c_la-dolce-casa-03-dining.jpg",
    coverImageAlt: "La Dolce Casa — Dining area with walnut table and lit wine display",
    metaDescription: "A private residence designed for a couple who enjoy the good things in life — warm wood, burgundy marble, bronze and a bar made for hosting. Interior design by element by elena mustakova.",
    images: [
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/c978a5f80e2fc32c_la-dolce-casa-01-lounge-view.jpg",
        alt: "La Dolce Casa – lounge with olive velvet sofas and countryside view"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/35b55efd343d996e_la-dolce-casa-02-lounge-bar.jpg",
        alt: "La Dolce Casa – lounge opening onto the bar and kitchen"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/3d20245735aaa05c_la-dolce-casa-03-dining.jpg",
        alt: "La Dolce Casa – dining area with walnut table and lit wine display"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/ed5b484d0c3fdbb7_la-dolce-casa-04-dining-detail.jpg",
        alt: "La Dolce Casa – dining table detail with view to the kitchen"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/b948c6ebe68ed8ad_la-dolce-casa-05-wine-display.jpg",
        alt: "La Dolce Casa – lit glass wine display"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/0994469ebf596905_la-dolce-casa-07-kitchen-island.jpg",
        alt: "La Dolce Casa – burgundy marble kitchen island"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/65cdd00f25efc89b_la-dolce-casa-08-open-plan.jpg",
        alt: "La Dolce Casa – open-plan view from the kitchen island"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/7ed6a81d726f544d_la-dolce-casa-09-bar-detail.jpg",
        alt: "La Dolce Casa – bar counter detail"
      },
      {
        url: "https://customer-assets-0z36b82j.emergentagent.net/job_sophisticated-spaces-1/artifacts/9b59fbf78cf6e68b_la-dolce-casa-10-living-tv-wall.jpg",
        alt: "La Dolce Casa – living area and TV wall"
      }
    ],
    description: "The brief was simple and personal: create a home where every day feels like an occasion.\n\nThe open living space flows from the kitchen to the dining table, the bar and the lounge, with nothing in between. Each zone has its own character, and together they work as one generous room built for hosting, or for an evening for two.\n\nAt the heart of the kitchen is a deep burgundy veined marble that carries through the island and the backsplash. A lit glass wine display frames the dining area. Between the columns sits a bar for an evening cocktail. In the lounge, olive-green velvet sofas and a burgundy pouf face floor-to-ceiling windows that open onto the countryside.\n\nThe materials are warm and tactile: natural wood, bronze accents, textured leather and soft layered curtains. Indirect lighting is set into the ceiling, so the space changes mood from morning coffee to late-night conversation.\n\nThe result is a home with the ease of a boutique hotel and the intimacy of a private retreat. It's designed around pleasure rather than display.",
    projectType: "Private residence",
    scope: "Interior design — living, dining, kitchen and bar",
    year: "2026",
    designer: "element by elena mustakova"
  },
  {
    id: 4,
    title: "MO! Apartment",
    category: "residential",
    coverImage: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ihy7etmf_Enscape_2026-07-09-12-45-10.png",
    coverImageAlt: "MO! Apartment — interior design by Element Studio, Sofia",
    coverImagePosition: "center 45%",
    metaDescription: "MO! Apartment: A residential interior design project in Sofia combining cosmic vibes with vintage chic. Custom pink bookshelves, artistic details, and gallery-like atmosphere create a one-of-a-kind living experience.",
    images: [
      {
        url: "/videos/mo-entrance.mp4",
        poster: "/videos/mo-entrance-poster.jpg",
        alt: "MO! Apartment - Entrance video walkthrough showcasing the cosmic energy and vintage charm",
        isVideo: true
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/n7gjm6wz_Enscape_2026-04-01-10-35-45.png",
        alt: "MO! Apartment - Living space with custom pink bookshelves"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/6vh12exg_Enscape_2026-04-01-10-44-59.png",
        alt: "MO! Apartment - Open plan living area"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/2k6nwxg0_Enscape_2026-04-01-10-53-00.png",
        alt: "MO! Apartment - Entryway with artistic details"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ydcfvb4o_Enscape_2026-04-01-10-57-09.png",
        alt: "MO! Apartment - Kitchen with marble countertops"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/tlv8pmdh_Enscape_2026-04-01-10-58-27.png",
        alt: "MO! Apartment - Kitchen and lounge area"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/9m1oxm5n_Enscape_2026-04-01-11-03-34.png",
        alt: "MO! Apartment - Living room with entertainment area"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/3ejw7zwl_Enscape_2026-03-20-11-39-50.png",
        alt: "MO! Apartment - Bedroom with MO! neon sign"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/g935zgz0_08-bedroom_close_uo.png",
        alt: "MO! Apartment - Bedroom detail with ambient lighting"
      }
    ],
    description: "The brief was to not build an apartment — to build an experience. A compact Sofia space where cosmic energy and vintage charm collide: every surface a reference, every corner a small discovery.\n\nThe kind of place that feels like it's been lived in by someone interesting, even on the first day."
  },
  {
    id: 2,
    title: "Design Squad Office",
    category: "commercial",
    coverImage: "/images/design-squad/detail4.png",
    coverImageAlt: "Design Squad Office — commercial interior design by Element Studio, Sofia",
    coverImagePosition: "center center",
    videoUrl: "https://youtu.be/V-Uy7wFtLe0",
    metaDescription: "Design Squad Office: Contemporary commercial office design combining warm wood tones with sophisticated materials. Collaborative workspaces, branded conference rooms, and inspiring creative environment in Sofia.",
    images: [
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/xjelc10k_entrance.png",
        alt: "Design Squad Office - Entrance with branded wall"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ok27rpwd_waiting%20area.png",
        alt: "Design Squad Office - Waiting area with warm wood accents"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/rh5gvsjt_workstations01.png",
        alt: "Design Squad Office - Open workstation area"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/9er95y58_workstations02.png",
        alt: "Design Squad Office - Workstations with modern furniture and greenery"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/7du66aso_workstations03.png",
        alt: "Design Squad Office - Collaborative workstation area"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/hpoizt0k_kitchen.png",
        alt: "Design Squad Office - Kitchen with island and bar seating"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/0ia1u4et_kitchen2.png",
        alt: "Design Squad Office - Modern kitchen and lounge area"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/swo0lonm_conference.png",
        alt: "Design Squad Office - Conference room with Element branding"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/cx0a1d9r_conference2.png",
        alt: "Design Squad Office - Conference room with view and lighting"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/5rzramwk_conference3.png",
        alt: "Design Squad Office - Material library and workspace"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/zctdqxsx_conference4.png",
        alt: "Design Squad Office - Conference room with warm wood tones"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/er0jr2aj_manager.png",
        alt: "Design Squad Office - Manager office with custom desk"
      }
    ],
    description: "The brief was unusual from the start. Design Squad make decorative panels — and their office would be dressed entirely in their own product.\n\nThat shifts the design problem. It's no longer what materials to use, but which ones, where, and why. Every panel had to earn its place: the right texture for focus, the right rhythm for energy, the right warmth for the in-between moments. Too much and the product overwhelms the space. Too little and the space forgets it has a story.\n\nThe result is an office that works as a living showroom without performing as one — productive, elegant, and with just enough personality to remind you that the people who make beautiful things should work somewhere beautiful too."
  },
  {
    id: 3,
    title: "Vitosha Apartment",
    category: "residential",
    coverImage: "/images/vitosha/vitosha1.png",
    coverImageAlt: "Vitosha Apartment — residential interior design by Element Studio, Sofia",
    metaDescription: "Vitosha Apartment: A refined city apartment in Sofia with mountain inspiration. Earthy, calming interiors bring serenity of nature into urban living, creating a tranquil sanctuary near Vitosha Mountain.",
    images: [
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ad8kw56g_03.png",
        alt: "Vitosha Apartment - Modern kitchen and dining area with warm wood tones, terracotta curtains, and contemporary lighting"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/3u1twrbf_01.png",
        alt: "Vitosha Apartment Sofia - Living room with mountain views, Element branding, and olive green sofa"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/jtdw0a9p_02.png",
        alt: "Vitosha Apartment - Open plan living and kitchen with earthy tones and modern artwork"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/hzrij447_04.png",
        alt: "Vitosha Apartment - Contemporary kitchen with marble island and mountain view window"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/psrfvrod_05.png",
        alt: "Vitosha Apartment - Bedroom workspace with Element branding and panoramic mountain views"
      },
      {
        url: "https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/28x453j8_06.png",
        alt: "Vitosha Apartment - Bedroom aerial view with integrated desk and warm wood flooring"
      }
    ],
    description: "A city apartment with the mountain in its bones. Facing Vitosha, this intimate rental draws from the calming presence just outside — earthy tones, a quiet palette, the kind of interior that makes the city feel less loud.\n\nA peaceful retreat that doesn't sacrifice sophistication for serenity.",
    location: "Sofia, Bulgaria (near Vitosha Mountain)"
  }
];
